import React from "react";
import LoadingWidget from "../../widgets/LoadingWidget";
import { Box } from "@material-ui/core";

const ButtonLoader = ({ isLoader }) => {
  return isLoader ? (
    <Box textAlign="center" p={0.5}>
      <LoadingWidget color="grey" />
    </Box>
  ) : null;
};

export default ButtonLoader;
